/**
 * Behavior Schema Registry
 *
 * Auto-generated schemas from behavior data interfaces.
 * Provides field metadata (types, defaults, labels) for editor UIs and runtime defaults.
 */

export type { FieldType, FieldSchema, BehaviorSchema } from './types';

import type { BehaviorSchema } from './types';
import { GENERATED_BEHAVIOR_SCHEMAS } from './generated';
import { getBehaviorConstructor } from '../../behaviors/BehaviorRegistry';

// ============================================================================
// Schema Registry
// ============================================================================

/** All behavior schemas indexed by type */
export const BEHAVIOR_SCHEMAS: Record<string, BehaviorSchema> = Object.fromEntries(
    GENERATED_BEHAVIOR_SCHEMAS.map(schema => [schema.type, schema])
);

/** Get schema for a behavior type */
export function getBehaviorSchema(type: string): BehaviorSchema | undefined {
    return BEHAVIOR_SCHEMAS[type];
}

/** Get all addable behavior types (only those with a registered constructor) */
export function getAddableBehaviorTypes(): string[] {
    return GENERATED_BEHAVIOR_SCHEMAS
        .filter(schema => getBehaviorConstructor(schema.type) !== undefined)
        .map(schema => schema.type);
}
